import { BusinessType } from "@kivunova/kivufrontendcommon";
import type { SidebarNavConfigEntry } from "../types/sidebarNavConfigTypes";
import { EDUCATION_SIDEBAR_CONFIG } from "./educationSidebarConfig";
import { MANUFACTURING_SIDEBAR_CONFIG } from "./manufacturingSidebarConfig";
import { RETAIL_SIDEBAR_CONFIG } from "./retailSidebarConfig";

/** Nav config keyed by JWT `businessType`. */
export const SIDEBAR_CONFIG_BY_BUSINESS_TYPE: Partial<
  Record<BusinessType, SidebarNavConfigEntry[]>
> = {
  [BusinessType.RETAIL]: RETAIL_SIDEBAR_CONFIG,
  [BusinessType.EDUCATION]: EDUCATION_SIDEBAR_CONFIG,
  [BusinessType.MANUFACTURING]: MANUFACTURING_SIDEBAR_CONFIG
};
